import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getCigFlowState, { CigFlowStateRes } from "../getCigFlowState";

const useGetCigFlowState = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<CigFlowStateRes | null>(
    null,
  );

  const send = useCallback(async () => {
    setLoading();
    try {
      const cigFlowState = await getCigFlowState();
      return setSuccess(cigFlowState);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetCigFlowState;
